import Message from "@intility/bifrost-react/Message";
import type { ReactNode } from "react";
import { type Capability, useCapabilities } from "./capabilities";

/**
 * Route guard: renders children only when the user holds the capability.
 * Fails closed (renders nothing) until the capability check resolves, so
 * deep links to gated pages never flash content or fire doomed requests.
 */
export default function RequireCapability({
  capability,
  children,
}: {
  capability: Capability;
  children: ReactNode;
}) {
  const { can, loaded } = useCapabilities();

  if (!loaded) return null;

  if (!can(capability)) {
    return (
      <div className="bf-content bfl-page-padding">
        <Message state="warning" header="No access">
          You don't have access to this page. Access is governed by the
          management store — contact an administrator if you believe this is
          wrong.
        </Message>
      </div>
    );
  }

  return <>{children}</>;
}
